import { Component, Input } from '@angular/core';
import { Navigator } from 'src/app/components/menu/navigator';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
    selector: 'app-signup-redirect',
    templateUrl: './signup-redirect.component.html',
    styleUrls: ['./signup-redirect.component.scss'],
})

export class SignupRedirectComponent {
    @Input() data: any;

    public email: string;

    constructor(
        private readonly events: EventsService,
        private readonly navigator: Navigator,
    ) {

    }

    ngOnInit(): void {
        this.email = this.extractEmail(this.data?.error?.error_message);
    }

    public navigateTo(page: string, options?: any): any {
        this.events.publish("event:social:guest:already", true);
        return this.navigator.navigateTo(page, options);
    }

    private extractEmail(errorMessage: string): string | null {
        const emailPattern = /[\w.-]+@[\w.-]+\.\w+/;
        const match = errorMessage?.match(emailPattern);
        return match ? match[0] : null;
    }

}